/**
 * Created by piotr.pozniak@thebeaverhead.com on 04/04/2024
 */

import React, { useContext } from "react";
import classnames from "classnames";
import useShowPopup from "../../../hooks/useShowPopup";
import SubscribePopup from "../../../WidgetsComponents/SubscribePopup";
import WidgetSettingsContext from "../../../contexts/WidgetSettingsContext";
import { useTranslation } from "react-i18next";

/**
 *
 * @param {String} title
 * @param {String} url
 * @param {String} RSSUrl
 * @param {String} text
 * @param {String} [className]
 * @param {String} [iCalPath]
 * @returns {React.JSX.Element|null}
 * @constructor
 */
const SubscribeCalendarButton = ({
  title,
  url,
  RSSUrl,
  text,
  className = "dc-calendar-subscribe-button",
  iCalPath = null,
}) => {
  const { onShow, showPopup } = useShowPopup({ url, title, text });
  const widgetSettings = useContext(WidgetSettingsContext);
  const { t } = useTranslation();

  const showCalendarSubscribe = widgetSettings["calendarShowSubscribe"] === 1;

  const popup = showPopup ? (
    <SubscribePopup
      url={url}
      title={title}
      text={text}
      onClose={onShow}
      RSSUrl={RSSUrl}
      iCalPath={iCalPath}
    />
  ) : null;

  if (!showCalendarSubscribe) {
    return null;
  }

  return (
    <div>
      <button
        type="button"
        onClick={onShow}
        className={classnames("dce-btn-reset", className)}
        aria-haspopup="dialog"
      >
        <i className={"material-icons"} aria-hidden="true">
          add
        </i>{" "}
        {t("Add to calendar")}
      </button>
      {popup}
    </div>
  );
};

export default SubscribeCalendarButton;
